import { Component } from 'shimmer'

import { Screen } from '@/webGL/objects/Screen'

import {
  Vector3
} from 'three'

const screenData = [
  {
    position: new Vector3(103, 1, -192.9),
    size: {
      width: 41,
      height: 53
    },
    rotation: 0,
    factor: 20
  },
  {
    position: new Vector3(142, 15.5, -177.50),
    size: {
      width: 26,
      height: 16.5
    },
    rotation: 0,
    factor: 20
  },
  {
    position: new Vector3(118.7, 14.5, -164.3),
    size: {
      width: 5.2,
      height: 10.5
    },
    rotation: -.35,
    factor: 20
  }
]

export class Screens extends Component {
  constructor (urls) {
    super('Screen')

    this.onDestroy = this.onDestroy.bind(this)
    this.play = this.play.bind(this)

    this.screens = []

    if (!urls.length) {
      return
    }

    screenData.forEach((datum, index) => {
      const screen = new Screen(urls[index] ? urls[index].url : urls[0].url, datum.size, datum.factor)

      screen.position.copy(datum.position)
      screen.rotation.x = datum.rotation

      screen.onPlay()

      this.screens.push(screen)

      this.add(screen)
    })
  }

  play () {
    this.screens.forEach(screen => screen.onPlay)
  }

  onDestroy () {
    this.screens.forEach(screen => {
      screen.onDestroy()
    })
  }
}